export default __webpack_public_path__ + "b16a76ce4c1e1a37f71c5247ce11f8af.svg";